import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    // Initialize dropdown as closed
    this.close()
  }

  toggle() {
    if (this.menuTarget.style.display === "none") {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.style.display = "block"
    // Add a click event listener to the document to close the dropdown when clicking outside
    this.clickOutHandler = this.clickOut.bind(this)
    document.addEventListener("click", this.clickOutHandler)
  }

  close() {
    if (this.hasMenuTarget) {
      this.menuTarget.style.display = "none"
    }
    // Remove the click event listener when closing
    if (this.clickOutHandler) {
      document.removeEventListener("click", this.clickOutHandler)
    }
  }

  clickOut(event) {
    // Only close if the click is outside the dropdown container
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}